import React, { useCallback } from "react"
import PropTypes from "prop-types"

import { ProgressModal } from "@components/Page"
import { ListAllProjectsOutputShape } from "@api/services/backstage"

import ReportFiltersForm from "../ReportFiltersForm"
import useProjectsReport from "./helpers/useProjectsReport"

const LABEL_TITLE = "Projects Report"


const ExportProjectsModal = ({ modal, projects = [] }) => {
  const onReady = () => modal.current.close()

  const [ percent, start, stop, reset ] = useProjectsReport(onReady)

  const renderFilters = useCallback(() =>
    <ReportFiltersForm
      onSubmit={start}
      projects={projects}
    />
  , [ start, projects ])

  const modalProps = {
    title: LABEL_TITLE,
    stop,
    reset,
    start,
    modal,
    percent,
    renderFilters,
  }

  return (
    <ProgressModal {...modalProps} />
  )
}

ExportProjectsModal.propTypes = {
  modal: PropTypes.shape().isRequired,
  projects: PropTypes.arrayOf(ListAllProjectsOutputShape),
}

export default ExportProjectsModal
